import { APP_GLOBALS_STORE_KEY } from '../actions/appGlobals.actions';
import { AppGlobalState, DependencyFilters, ReduxStore } from '../types';

export const getAppState = (state: ReduxStore): AppGlobalState => state[APP_GLOBALS_STORE_KEY];

export const getDependencyFilters = (state: ReduxStore): DependencyFilters => getAppState(state).dependencyFilters;
